import { useState } from 'react';

import {
  ChakraBox,
  ChakraFlex,
  DateFormat,
  Popover,
  RiskLevel,
  Tag,
  TagColor,
  Text,
} from '@equip.health/ui';
import { DateTime } from 'luxon';

import {
  getCssrsRiskLevel,
  getLatestCssrsAssessment,
} from '~/lib/util/patientAlerts.util';
import { useGetGroupedAssessmentsQuery } from '~/store/services/assessments';

type Props = {
  id: string;
  patientId: string;
  genderOnRecord: string;
};
export const PatientHeaderSuicideRiskTag = ({
  id,
  patientId,
  genderOnRecord,
}: Props) => {
  const { data: groupedAssessments, isLoading: isGroupedAssessmentsLoading } =
    useGetGroupedAssessmentsQuery({
      patientId,
    });

  const [isSRRiskPopoverOpen, setIsSRRiskPopoverOpen] = useState(false);

  if (isGroupedAssessmentsLoading) {
    return <></>;
  }

  const latestCssrsAssessment = getLatestCssrsAssessment(
    groupedAssessments.surveys,
  );

  const cssrsRiskLevel = latestCssrsAssessment
    ? getCssrsRiskLevel(latestCssrsAssessment, genderOnRecord)
    : null;

  if (cssrsRiskLevel !== RiskLevel.HIGH) {
    return <></>;
  }

  return (
    <Popover
      bodyContent={
        <ChakraFlex direction="column" padding={1}>
          <Text size="sm" variant="captionMedium">
            Suicide Risk
          </Text>
          <Text size="sm" variant="caption">
            Patient has expressed thoughts of suicide and/or self harm
          </Text>
          <Text size="sm" variant="caption">
            {latestCssrsAssessment.surveyName}
          </Text>
          <Text size="sm" variant="caption">
            Submitted on{' '}
            {DateTime.fromISO(latestCssrsAssessment.updatedDate).toFormat(
              DateFormat.longDate,
            )}
          </Text>
        </ChakraFlex>
      }
      id={`${id}_sr-tag-tooltip`}
      isOpen={isSRRiskPopoverOpen}
      minWidth="375px"
      onClose={() => setIsSRRiskPopoverOpen(false)}
      onOpen={() => {
        setIsSRRiskPopoverOpen(true);
      }}
      size="md"
      trigger="hover"
      triggerContent={
        <ChakraBox>
          <Tag
            color={TagColor.red}
            data-testid={`${id}_sr-tag`}
            id={`${id}_sr-tag`}
            size="sm"
            value="SR"
          />
        </ChakraBox>
      }
    />
  );
};
